import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, NavigationExtras,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { ExportgridComponent } from '../../grid/exportgrid/exportgrid.component';
@Component({
  selector: 'app-leavereport',
  templateUrl: './leavereport.component.html',
  styleUrls: ['./leavereport.component.css']
})
export class LeavereportComponent implements OnInit{

  @ViewChild('filterbar',{static:false}) filterbar;

  isadd:boolean=false;
  isedit:boolean=false;
  isdelete:boolean=false;
  isview:boolean=false;
  isprint:boolean=false;
  isexport: boolean = false;
  isfilter: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;


  formname: string = "LeaveReport";

  fromdate: any = new Date();
  todate: any = new Date();

  filterstatus: string = "ALL";
  dtOptions: DataTables.Settings = {};
    
  leaveColl:any=[];
 
  searchtxt: any = "";


  columnDefs = [
    { headerName: 'Employee', field: 'empname' },
    { headerName: 'Leave Type', field: 'leavetype', filter: true},  
    {
      headerName: 'Start On', field: 'startdt', type:'date'
    },
    {
      headerName: 'End On', field: 'enddt',type:'date'
    },
  
    { headerName: 'Status', field: 'approvedstatus', },

  ]

  gridOptions = {
    enableactioncol: false,
    columnDefs: this.columnDefs,
  }; 

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor( private appService:AppdataService,private loginService:LoginserviceService,public router: Router,private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService,private toastr: ToastrService,private datePipe: DatePipe,private productFindService: NgbModal,) {
      this.fnServiceChanges();

      this.dateCustomClasses = [
        { date: new Date(), classes: ['bg-warning'] },
      ];
      this.fromdate.setDate(this.fromdate.getDate() - 15);
  }
  
  //Company Check
  fnServiceChanges(){
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }   
        
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }
  
  //Init
  ngOnInit() {
    try{
      if(this.loginService.fnCheckCompany()){         
        this.fnCheckPrivilage();
        if(this.isview){
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }          
      }
      else{
        this.loginService.fnGetUserRoleList();
      } 
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm(){
    this.fngetLeaveReport();     
  }


  fnCheckPrivilage() {
    
    this.isadd=this.loginService.fnCheckUserRoleAction(this.formname,'CREATE');
    this.isedit=this.loginService.fnCheckUserRoleAction(this.formname,'ALTER');
    this.isdelete=this.loginService.fnCheckUserRoleAction(this.formname,'DELETE');
    this.isview=this.loginService.fnCheckUserRoleAction(this.formname,'VIEW');
    this.isprint=this.loginService.fnCheckUserRoleAction(this.formname,'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
    
    
  }

  fnUserFailedForm(){
    this.isprivilage=true;
  }

 
    fnActionExportClick()  {
        const params = {
          columnGroups: true,
          allColumns: true,
          fileName: 'leavelist',
          //columnSeparator: document.querySelector("#columnSeparator").value
        };
         
    }
    fnActionFilterClick() {  

      this.filterbar.filterstatus = this.filterstatus;
      
      this.isfilter = !this.isfilter;
    }
    fnActionRefreshClick() { 
      this.fngetLeaveReport()
    }
    fnApplyFilter(data) {
     // this.isfilter = !this.isfilter;
  
      this.filterstatus = data;
  
      this.fngetLeaveReport();
       
    }
  
    fnCurrentRouteChange() { 
      var queryParams = {};
      
  
      if (this.filterstatus != '') {     
        queryParams['status'] = this.filterstatus;
      }   
  
       this.router.navigate(
        [], 
        {
          relativeTo: this.route,
          queryParams: queryParams, 
        
        });
    }
    
    
  
  
  //Get
  fngetLeaveReport() {
    if(this.showProgress){
      return;
    }

    this.fnShowProgress();       
      var data = {
          'leaveid':0,
          'companyid': this.loginService.fnGetCompanyId(),  
          'filterstatus':this.filterstatus ,                                                                          
          'fromdate': this.fnFormatDatetime(this.fromdate),
          'todate': this.fnFormatDatetime(this.todate),
      }
      this.appService.getLeaveReport(data)
      .subscribe(
          (res)=>{                  
            if(res.json().status===200){
              this.fnHideProgress();                   

              this.leaveColl = res.json().result;   
              this.fnSetTable();
            this.fnCurrentRouteChange();        
              
            }else {
              this.fnHideProgress();                   

                this.loginService.fnAPIError(res.json())
            }             
          },
          (err)=>{  
            this.fnHideProgress();                   
        
              this.toastr.error('Error', err);
      })
  }
  


  
  private fnExport() {

    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.leaveColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  
  } 


  fnSetTable() {
 
  }

  public fnSearchDatatable(value){    
  
  }

  private fnFocusTableRow(index,status){
    if(index>-1){
      if(status==='IN'){          
        this.leaveColl[index].hoverfocus="IN"
      }
      else{
        this.leaveColl[index].hoverfocus=""
      }                
    }    
}
  
  
fnMomentDateFormatter(params) {
  if (params.value) {
    return moment(params.value).format('DD-MM-YYYY');//  
  }
  else {
    return '';
  }

}
fnFormatDatetime(dt){
  if(dt){
    if(dt===""){
      return null
    }
    else{
      return this.datePipe.transform(dt,"yyyy-MM-dd")  
    }
    
    }else {
    return null
  }
  
}
  
fngetDescriptionRefno(data){
  var rtnstr="";
  try{
      if(data.transdt){
        rtnstr=rtnstr+data.transdt;
      }

      if(data.empid){
        rtnstr=rtnstr+" - "+data.empid;
      }

      if(data.empname){
        rtnstr=rtnstr+" - "+data.empname;
      }
    }catch{
    
    }
  return rtnstr;
}
fnCloseForm(){
  try{
    this.router.navigate(['/Reports']);
  }catch(ex){
     this.fnShowErrorMsg(ex);
  }
  }
  


fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
} 
  private  fnShowErrorMsg(ex){
    this.toastr.warning('Internal Error', ex);       
  }








}
